import { LAY_THE_GROUNDWORK } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guideData/LayTheGroundwork/index";
import { FaireAcademyGuide } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/types";
import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
import { IFaireAcademyGuide } from "@faire/web-api--source/indigofair/data/IFaireAcademyGuide";

const { useStore: useGuideStore, Provider: GuideStoreProvider } =
  createContextStore<{
    guide: FaireAcademyGuide;
    guideBackendData?: IFaireAcademyGuide;
  }>(
    {
      guide: LAY_THE_GROUNDWORK,
    },
    { name: "GuideStore" }
  );

export { useGuideStore, GuideStoreProvider };
